import styled from "styled-components";

export const AuthModalHeaderTitleContainer = styled.div`
  width: 100%;

  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  margin-bottom: 1.5rem;

  > .auth-modal-header-title {
    all: unset;
    color: ${({ theme }) => theme.authModal.primaryText};
    font: 600 1.125rem/1.406rem "Inter";
    text-align: center;
  }

  > .auth-modal-header-subtitle {
    all: unset;
    color: ${({ theme }) => theme.authModal.secondaryText};
    font: 400 0.813rem/1.219rem "Inter";
    text-align: center;
  }
`;
